angular.module('ihestiaCommonDirectives.apk')
    .service('apkSvc', ['$compile', '$http', '$q', '$document', '$rootScope', '$state', '$window', 'ihestiaConfigHelper', '$filter', 'lsnCookie', function ($compile, $http, $q, $document, $rootScope, $state, $window, ihestiaConfigHelper, $filter, lsnCookie) {
        this.isAPKDone = false;
        this.apkCreateUrl = null;
        this.translations = {};
        this.isReload = {};

        // Obsługa `beforeunload`, aby ustawić ciasteczko w przypadku opuszczenia strony
        $window.addEventListener('beforeunload', beforeUnloadFun.bind(this));

        this.init = function () {
            if (!this.isReload()) {
                var cookieValue = getIsAPKDoneCookie();
                if (cookieValue === null) {
                    this.isAPKDone = false;
                } else {
                    this.isAPKDone = cookieValue === true;
                    //'reset' wartości ciasteczka
                    setIsAPKDoneCookie(false);
                }
            } else {
                //'reset' wartości ciasteczka
                setIsAPKDoneCookie(false);
            }

            this.apkCreateUrl = ihestiaConfigHelper.get('ihsgDefines').APK_URL + 'apks/create';
            this.translations = {
                nextBtn: $filter('translate')('next', {componentCode: 'Public'}),
                cancelBtn: $filter('translate')('Public.cancel', {componentCode: 'Public'}),
                internalOption: $filter('translate')('sp2.modal.apk.choice.internal', {componentCode: 'sp2'}),
                externalOption: $filter('translate')('sp2.modal.apk.choice.external', {componentCode: 'sp2'}),
                modalMsg: $filter('translate')('sp2.modal.apk.choice.description', {componentCode: 'sp2'}),
                header: $filter('translate')('sp2.modal.apk.header', {componentCode: 'sp2'})
            };
        };

        this.openModal = function () {
            var modalScope = $rootScope.$new();  // Tworzymy nowy scope, by kontrolować modal
            var deferred = $q.defer();

            // Definiujemy HTML modala bezpośrednio w kodzie
            //Modal używany w wielu różnych libach i appkach(np. ihestia.portal, widgets)
            //stąd decyzja o umieszczeniu html w kodzie
            var modalHTML =
                '<div class="modal-backdrop am-fade in"></div>' +
                '<div class="modal am-fade-and-scale" style="display: block;" tabindex="-1">' +
                '<div class="modal-dialog modal-sm" style="width: 700px;">' +
                '<div class="modal-content">' +
                '<div class="modal-header">' +
                '<h3 class="modal-title">' +
                this.translations.header +
                '</h3>' +
                '</div>' +
                '<div class="modal-body" style"padding: 14px";>' +
                '<div style="padding-top: 7px; padding-bottom: 9px; white-space: pre-line;">' +
                this.translations.modalMsg +
                '</div>' +
                '<div style="margin-left: 8px;">' +
                '<div class="row">' +
                '<label class="input-radio">' +
                '<input type="radio" name="apkStatus" ng-model="apkStatus" ng-value="\'APK_DONE\'">' +
                this.translations.externalOption +
                '<span style="top:5px;">' +
                '<i class="icon-sl-fill icon-record-1"></i>' +
                '</span>' +
                '</label>' +
                '</div>' +
                '<div class="row">' +
                '<label class="input-radio">' +
                '<input type="radio" name="apkStatus" ng-model="apkStatus" ng-value="\'APK_TO_BE_DONE\'">' +
                this.translations.internalOption +
                '<span style="top:5px;">' +
                '<i class="icon-sl-fill icon-record-1"></i>' +
                '</span>' +
                '</label>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<div class="modal-footer">' +
                '<button class="btn btn-default" type="button"  ng-click="dismissModal()">' +
                this.translations.cancelBtn +
                '</button>' +
                '<button class="btn btn-primary" type="button" ng-click="closeModal()" ng-disabled="!apkStatus">' +
                this.translations.nextBtn +
                '</button>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            // Kompilowanie HTML-a w kontekście angularjs
            var modalElement = angular.element(modalHTML);
            var compiledElement = $compile(modalElement)(modalScope);
            angular.element($document[0].body).append(compiledElement);


            modalScope.dismissModal = function () {
                compiledElement.remove();  // Usuwamy modal z DOM-u
                deferred.reject();
                modalScope.$destroy();  // Usuwamy scope modala
            };

            modalScope.closeModal = function () {
                compiledElement.remove();  // Usuwamy modal z DOM-u
                deferred.resolve(modalScope.apkStatus);  // Zwracamy wynik w Promise
                modalScope.$destroy();  // Usuwamy scope modala
            };

            //jeśli nastąpi zmiana w routerze — zamykamy modal
            var routerListener = $rootScope.$on('$stateChangeStart', function () {
                // Sprawdź, czy modal jest otwarty i zamknij go
                if (modalScope) {
                    modalScope.dismissModal();  // Wywołanie funkcji, która zamyka modal
                }
            });

            modalScope.$on('$destroy', function () {
                routerListener(); // Usuwamy nasłuch na zmiany stanu
            });

            return deferred.promise;  // Zwracamy Promise
        };

        this.getAPKPostfix = function (previousPostfix) {
            if (previousPostfix !== null && previousPostfix.includes('?')) {
                return previousPostfix + '&apkType=external';
            } else {
                return 'external/init?apkType=external';
            }
        };

        this.showModalWithRedirectCallback = function (redirectCallback) {
            var self = this;
            if (typeof redirectCallback !== 'function') {
                throw new Error('Redirect callback must be a function');
            }
            if (this.isAPKDone) {
                this.isAPKDone = false;
                redirectCallback();
                $state.go('main.mainPage');
            } else {
                this.openModal().then(function (result) {
                    self.isAPKDone = false;
                    if (result === 'APK_TO_BE_DONE') {
                        $window.open(self.apkCreateUrl, '_blank');
                    } else {
                        redirectCallback();
                    }
                    $state.go('main.mainPage');
                }).catch(function () {
                    //empty
                });
            }
        };

        this.isReload = function () {
            if ($window.performance) {
                // Nowoczesne API PerformanceNavigationTiming
                if (typeof $window.performance.getEntriesByType === 'function') {
                    var navigationEntries = $window.performance.getEntriesByType('navigation');
                    if (navigationEntries && navigationEntries.length > 0) {
                        return navigationEntries[0].type === 'reload';
                    }
                }
                // Starsze API performance.navigation.type
                if ($window.performance.navigation) {
                    return $window.performance.navigation.type === $window.performance.navigation.TYPE_RELOAD;
                }
            }
            return false; // API performance nie jest obsługiwane
        };

        function setIsAPKDoneCookie(value) {
            lsnCookie.set('isAPKDone', value, {
                'domain': ihestiaConfigHelper.get('crossTab').ROOT_DOMAIN
            });
        }

        function getIsAPKDoneCookie() {
            var cookie = lsnCookie.get('isAPKDone');
            if (typeof cookie === 'undefined') {
                return null;
            }
            return cookie;
        }

        function beforeUnloadFun() {
            setIsAPKDoneCookie(this.isAPKDone);
        }

        this.init();

    }]);